import { render, staticRenderFns } from "./journeyList.vue?vue&type=template&id=799a88eb&scoped=true"
import script from "./journeyList.vue?vue&type=script&lang=js"
export * from "./journeyList.vue?vue&type=script&lang=js"
import style0 from "./journeyList.vue?vue&type=style&index=0&id=799a88eb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799a88eb",
  null
  
)

export default component.exports